import { createGlobalStyle } from "styled-components";

import { palettes } from "./antd/antd";
import { colors } from "./colors";

export const AntdSelectStyles = createGlobalStyle`
  .ant-select-dropdown .rc-virtual-list-holder-inner {
    margin: 0 4px !important; // style of margin-left: 0 gets added as a style by antd
  }

  .ant-select-selection-item {
    font-size: 12px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.GREY_700};
  }

  .ant-select-disabled {
    .ant-select-selection-item {
      color: rgba(0, 0, 0, 0.25);
    }
  }

  .ant-select-item {
    font-size: 12px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.GREY_700};
    border-radius: 4px;

    &:hover {
      background: ${({ theme }) => theme.colors.GREY_50};
    }
  }

  .ant-select.ant-select-open .ant-select-arrow {
    transform: rotate(180deg);
    svg {
      color: ${colors.ACCENT_BLUE_500};
    }
  }

  .ant-select-item-group {
    color: rgba(0, 0, 0, 0.45);
  }
  .ant-select-item-group:hover {
    background-color: transparent;
  }

  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
    background: ${colors.ACCENT_BLUE_500_50};
    font-weight: 400;
  }
`;

export const AntdNoPaddingDropdownStyles = createGlobalStyle`
  .no-padding-dropdown {
    padding: 0px;
  }
  .ant-select-dropdown.no-padding-dropdown .rc-virtual-list-holder-inner {
    margin: 0px;
  }
  .no-padding-dropdown .ant-select-item {
    border-radius: 0px;
  }
  .no-padding-dropdown .ant-select-item.ant-select-item-option{
    padding-left: 16px;
  }
`;

export const AntdNoPaddingPopoverStyles = createGlobalStyle`
  .no-padding-popover .ant-popover-inner-content {
    padding: 0;
  }
`;

export const AntdDatePickerStyles = createGlobalStyle`
  .ant-picker-dropdown {
    font-size: 12px;
  }
`;

export const ElementFlashStyles = createGlobalStyle`
  .flash {
    border-color: ${(props) => props.theme.colors.ACCENT_ORANGE} !important;
    box-shadow: 0px 0px 4px 0.5px ${(props) =>
      props.theme.colors.ACCENT_BLUE_600} !important;
  }

`;

const antdAccentRowClassName = "accent-row";
export const AntdTableRowStyle = createGlobalStyle`
  .${antdAccentRowClassName} {
    td:first-child {
      border-left: 3px solid ${palettes["@blue-base"]};
      background: linear-gradient(90deg, rgba(39, 187, 255, 0.12) 0%, rgba(39, 187, 255, 0) 100%);
      color: ${palettes["@blue-base"]};
    }
  }
`;

export const AntModalStyles = createGlobalStyle`
  .ant-modal-wrap {
    overflow: hidden;
    display: flex;
    align-items: center;
  }

  .ant-modal {
    top: auto;
    padding: 0;
  }

  .ant-modal-content {
    height: 100%;
  }
`;

export const AntDPlatformNotificatonStyles = createGlobalStyle`
  .platform-notification {
    minWidth: 430px;
    max-width: min(calc(100vw - 20px), 530px);
    width: auto;

    &.ant-notification-notice-success {
      border-left: 2px solid ${({ theme }) => theme.colors.SUCCESS};
    }
    &.ant-notification-notice-warning {
      border-left: 2px solid ${({ theme }) => theme.colors.WARNING};
    }
    &.ant-notification-notice-error {
      border-left: 2px solid ${({ theme }) => theme.colors.DANGER};
    }
    &.ant-notification-notice-info {
      border-left: 2px solid ${({ theme }) => theme.colors.INFO};
    }
  }
`;

export const AntdCollapseStyles = createGlobalStyle`
  .ant-collapse.ant-collapse-icon-position-end .ant-collapse-header
    .ant-collapse-expand-icon {
      position: absolute;
      left: auto;
      right: 0;
      margin: 0;
      transform: translateY(-50%);
      top: 50%;
    }
`;

// tox is used to display the file picker for the rich text editor
export const TinyMceStyles = createGlobalStyle`
  .tox-collection__item-icon {
    svg path {
     fill: ${({ theme }) => theme.colors.GREY_300};
    }
    svg.no-fill path {
      fill: transparent;
    }
  }
    .tox-collection__item {
    fill: ${({ theme }) => theme.colors.GREY_300};
    color: ${({ theme }) => theme.colors.GREY_500};
  }

  .tox-toolbar__overflow {
    .tox-icon svg path {
      fill: ${({ theme }) => theme.colors.GREY_300};
    }
    .tox-icon svg.no-fill path {
      fill: transparent;
    }
  }
`;

export const AntdPopconfirmStyles = createGlobalStyle`

.ant-popconfirm {
  max-width: 200px;
  .ant-popover-arrow {
    display: none;
  }
  .ant-popover-inner {
    box-shadow: 0px 0px 1px 0px rgba(34, 39, 47, 0.16), 0px 12px 32px -8px rgba(34, 39, 47, 0.16), 0px 1px 3px 0px rgba(34, 39, 47, 0.06);

    .ant-popover-inner-content {
      padding: 12px;
      .ant-popover-message {
        width: 100%;
        overflow: hidden;
        padding-top: 0px;
        > .anticon {
          top: 4px;
        }
        .ant-popover-message-title {
          font-size: 13px;
          color: ${({ theme }) => theme.colors.GREY_500};
          line-height: 20px;
          text-align: left;
          word-wrap: break-word;
          overflow: hidden;
        }
      }

    }
    .ant-popover-buttons {
      display: flex;
      justify-content: end;
      margin-bottom: 0px;
      button {
        flex: 1;
      }
      button:first-child {
        margin-left: 0px;
      }
      button:not(:first-child) {
        margin-left: 12px;
      }
    }
  }

  }

  .no-icon-popconfirm {
    .ant-popover-message-title {
      padding-left: 0px;
    }
  }
  `;

export const AntdButtonStyles = createGlobalStyle`
    .ant-btn-dangerous.ant-btn-primary {
      border-color: ${({ theme }) => theme.colors.DANGER};
      background:  ${({ theme }) => theme.colors.DANGER};
      &:hover {
        border-color: ${({ theme }) => theme.colors.DANGER};
        background:  ${({ theme }) => theme.colors.DANGER};
        opacity: 0.7;
      }
    }
    .ant-btn-dangerous.ant-btn-secondary {
      border-color: ${({ theme }) => theme.colors.DANGER};
      &:hover {
        border-color: ${({ theme }) => theme.colors.DANGER};
        opacity: 0.7;
      }
    }
  `;

export const AntdBreadCrumbStyles = createGlobalStyle`
  .ant-breadcrumb {
    font-size: 12px;
    a {
      color: ${colors.GREY_400};
    }
    .ant-breadcrumb-separator {
    color: #00000073;
    }
    .ant-breadcrumb-link {
      color: ${colors.GREY_700};
    }
  }
`;

export const AntdAlertStyles = createGlobalStyle`
  .ant-alert {
    font-size: 12px;
    color: ${colors.GREY_700};
  }
  .ant-alert.ant-alert-warning {
    background: ${colors.ACCENT_ORANGE_04};
    border: 1px solid ${colors.ACCENT_ORANGE_24};
    border-radius: 4px;
  }
`;

export const AntdTabStyles = createGlobalStyle`
  .ant-tabs-tab {
    padding: 8px 10px 8px 10px;
  }
  .ant-tabs-tab+.ant-tabs-tab {
    margin-left: 4px;
  }
  .ant-tabs-tab-btn {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: ${colors.GREY_500};
  }

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${colors.GREY_900};
    font-weight: 500;
  }
`;

export const AntdCheckBoxStyles = createGlobalStyle`
  .ant-checkbox-wrapper {
    font-size: 12px;
  }
`;
